import { useRoute } from 'vue-router';
import { useDevice } from 'next-vue-device-detector';
import { getStationInfo } from '@/assets/api/login';
import { useStore } from 'vuex';
import TapBar from './mobile/components/TapBar/index.vue';
export default {
  name: 'APP',
  setup() {
    const $store = useStore();
    const route = useRoute();
    const {
      mobile
    } = useDevice();
    const setStationInfo = async () => {
      const result = await getStationInfo();
      if (result.code == 200) {
        const data = result.data;
        $store.commit('setStationInfo', data);
        // 站点icon
        const stationIcon = data.plug_corner_icon;
        // 设置
        document.title = $store.getters.stationFullName;
        // 图标元素
        const iconLinkElem = document.querySelector('link[rel="icon"]');
        if (iconLinkElem) {
          iconLinkElem.href = stationIcon;
        }
      }
    };
    setStationInfo();
    if (mobile) {
      const userInfo = JSON.parse(localStorage.getItem('wp_userInfo'));
      if (userInfo) {
        $store.commit('setUserInfo', userInfo);
      }
    }
    return {
      mobile,
      route
    };
  },
  components: {
    TapBar
  }
};